module.exports = __webpack_public_path__ + "img/单面建模.d2ddff0e.gif";